import * as React from 'react';
import { useSelector } from 'react-redux';

import Text from 'antd/lib/typography/Text';
import { antGrey, releaseStepDetailsContainerModuleStyle } from '../styles/globalStyles';
import { TestRun } from '../../types';
import RegressionTestingCharts from './regressionTestingCharts';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import Collapse from 'antd/lib/collapse';
import RegressionTestingRunHeader from './RegressionTestingRunHeader';
import { RootState } from '../../reducers/reducers';
import { selectAppTimeFormatSetting, selectEffectiveTimezone } from '../../selectors/selectors';

interface RegressionTestingActiveTestRunsProps {
    testRuns: TestRun[];
    appId: string;
}

const RegressionTestingActiveTestRuns: React.FC<RegressionTestingActiveTestRunsProps> = (
    props: RegressionTestingActiveTestRunsProps,
) => {
    const use24HourTimeFormat = useSelector((state: RootState) => selectAppTimeFormatSetting(state, props.appId));
    const effectiveTimezone = useSelector((state: RootState) => selectEffectiveTimezone(state, props.appId));
    const [expandedKeys, setExpandedKeys] = React.useState<string[]>([]);

    return (
        <div
            style={{
                marginBottom: 24,
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minWidth: 0,
            }}
        >
            <Text style={{ fontSize: 20, color: antGrey.grey7, marginBottom: 16 }}>Current test runs</Text>
            <div
                style={{
                    ...releaseStepDetailsContainerModuleStyle,
                    marginBottom: 25,
                }}
            >
                <Collapse
                    ghost
                    activeKey={expandedKeys}
                    onChange={(keys) => setExpandedKeys(Array.isArray(keys) ? keys : [keys])}
                >
                    {props.testRuns.map((testRun: TestRun, index: number) => {
                        const { name, integrationId, url, createdAt, completedAt, completionFraction, statuses } =
                            testRun;

                        const [icon, alt] = iconAndAltForIntegrationType(integrationId);
                        const percentComplete = parseFloat((completionFraction * 100).toFixed(0));

                        return (
                            <Collapse.Panel
                                className="collapse-test-runs"
                                key={String(index)}
                                header={
                                    <RegressionTestingRunHeader
                                        name={name}
                                        integrationIcon={icon}
                                        integrationIconAlt={alt}
                                        percentComplete={percentComplete}
                                        completedAt={completedAt}
                                        url={url}
                                        createdAt={createdAt}
                                        use24HourTimeFormat={use24HourTimeFormat}
                                        effectiveTimezone={effectiveTimezone}
                                        statuses={statuses}
                                        isExpanded={expandedKeys.includes(String(index))}
                                    />
                                }
                            >
                                <RegressionTestingCharts {...testRun} />
                            </Collapse.Panel>
                        );
                    })}
                </Collapse>
            </div>
        </div>
    );
};

export default RegressionTestingActiveTestRuns;
